import React from 'react';
import { Paper } from '@mui/material';

/** Common rounded-panel card wrapper used across the dashboard. */
export default function Card({ children, sx, variant, ...rest }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '20px',
        p: '20px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
        bgcolor: 'background.paper',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Paper>
  );
}
